import { Paper, styled, Typography, css } from '@mui/material';
import ProgressionTick from 'assets/icons/ProgressionTick';
import ZizziPoint from 'assets/icons/ZizziPoint';
import { palette } from 'assets/styles/colors';
import { theme } from 'assets/themes/zizzi';

const userNotVisited = palette.neutral[50];
const visitBackground = palette.blue[500];

interface CompletedProps {
  complete: string;
  tier?: number;
}

export const StyledPaper = styled(Paper)`
  width: 65px;
  height: 108px;
  padding: 0;

  @media (max-width: 349px) {
    width: 45px;
  }

  ${theme.breakpoints.up('sm')} {
    width: 126px;
    height: 162px;
  }
`;

export const StyledBox = styled('div')<CompletedProps>`
  height: 65%;
  background: ${userNotVisited};
  border-radius: 7px 7px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;

  ${({ complete }) =>
    complete === 'true' &&
    css`
      background: ${visitBackground};
      color: white;
    `};
`;

export const BalanceBox = styled('div')<CompletedProps>`
  height: 35%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ complete }) =>
    complete === 'true' &&
    css`
      opacity: 0.5;
    `};
`;

export const VisitText = styled(Typography)`
  font-size: 18px;
  margin-bottom: 0;

  @media (max-width: 349px) {
    font-size: 16px;
  }

  ${theme.breakpoints.up('sm')} {
    font-size: 24px;
    margin-bottom: 10px;
  }
`;

export const PointsPerVisit = styled(Typography)`
  font-size: 16px;
  display: flex;
  margin-bottom: 0;

  @media (max-width: 349px) {
    font-size: 14px;
  }
  ${theme.breakpoints.up('sm')} {
    font-size: 22px;
  }
`;

const tickSizeSm = 24;
const tickSizeLg = 32;

export const Tick = styled(ProgressionTick)<CompletedProps>`
  position: absolute;
  top: -${tickSizeSm / 2}px;
  right: -${tickSizeSm / 2}px;
  height: ${tickSizeSm}px;
  width: ${tickSizeSm}px;

  ${theme.breakpoints.up('sm')} {
    top: -${tickSizeLg / 2}px;
    right: -${tickSizeLg / 2}px;
    height: ${tickSizeLg}px;
    width: ${tickSizeLg}px;
  }

  ${({ complete }) =>
    complete === 'false' &&
    css`
      display: none;
    `};
`;

export const StyledLogo = styled(ZizziPoint)`
  height: 22px;
  width: 22px;
  margin-bottom: -3px;

  ${theme.breakpoints.up('sm')} {
    height: 35px;
    width: 35px;
  }
`;
